import { useApproveBankAccount } from '@api';
import { modals } from '@mantine/modals';
import { AxiosError } from 'axios';
import { useTranslation } from 'react-i18next';
import { useNotification } from '../../../useNotification';

const TRANS_PATH_MODAL = 'BANK_ACCOUNTS.APPROVE';
const TRANS_PATH_NOTIFICATION = 'NOTIFICATIONS.APPROVE_BANK_ACCOUNT';

type UseApproveBankAccountMutationReturnType = {
  handleApproveBankAccount: (bankAccountId: string) => void;
};

export const useApproveBankAccountMutation =
  (): UseApproveBankAccountMutationReturnType => {
    const { t } = useTranslation();
    const { showSuccess, showError } = useNotification();
    const { mutate: mutateApprove } = useApproveBankAccount();

    const onSuccess = (): void => {
      showSuccess({
        title: `${TRANS_PATH_NOTIFICATION}.SUCCESS.TITLE`,
        message: `${TRANS_PATH_NOTIFICATION}.SUCCESS.MESSAGE`,
      });
    };

    const onError = (error: AxiosError): void => {
      showError({
        title: `${TRANS_PATH_NOTIFICATION}.ERROR.TITLE`,
        message: `${TRANS_PATH_NOTIFICATION}.ERROR.MESSAGE`,
        error,
      });
    };

    const handleApproveBankAccount = (bankAccountId: string): void => {
      modals.openConfirmModal({
        title: t(`${TRANS_PATH_MODAL}.CONFIRMATION_TITLE`),
        labels: {
          confirm: t(`${TRANS_PATH_MODAL}.CONFIRM_BUTTON`),
          cancel: t('CANCEL_BUTTON'),
        },
        confirmProps: {
          color: 'green',
        },
        onConfirm: () => {
          mutateApprove(
            { bankAccountId },
            {
              onSuccess,
              onError,
            }
          );
        },
      });
    };

    return { handleApproveBankAccount };
  };
